var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "drawer-panel-inner" }, [
    _c(
      "div",
      { ref: "items-wrap", staticClass: "drawer-panel-inner__items-wrap" },
      [_vm._t("default")],
      2
    ),
    _c(
      "div",
      { ref: "controls", staticClass: "drawer-panel-inner__controls" },
      [
        _vm._t("footer", [
          _c("ui-button", {
            attrs: { wide: "", secondary: "", large: "", text: "Сбросить" },
            on: {
              click: function($event) {
                return _vm.$emit("clear")
              }
            }
          }),
          _c("ui-button", {
            attrs: { wide: "", large: "", text: "Применить" },
            on: {
              click: function($event) {
                return _vm.$emit("apply")
              }
            }
          })
        ])
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }